import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface PropertyNotesRequest extends Partial<AxiosRequestConfig> {
  params: {
    propertyId: string
  }
}

export interface PropertyNoteType {
  id: string | null
  creator: string | null
  editor: string | null
  created_dt: string | null
  updated_dt: string | null
  property_notes: string | null
  host_notes: string | null
}

export interface PropertyNotesResponse extends AxiosResponse {
  data: {
    apiStatus: string
    data: PropertyNoteType[]
  }
}

export function getPropertyNotesApi(
  {
    params,
    method = "get",
    url = `/property/notes/${params.propertyId}`,
    ...config
  }: PropertyNotesRequest,
  axiosInstance: AxiosInstance,
): Promise<PropertyNotesResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<PropertyNotesResponse>
}
